import { initializeApp } from 'firebase/app';
import { getAuth, signOut, getIdToken, onAuthStateChanged } from 'firebase/auth';
import querystring from 'query-string';

import { EDITOR_WINDOW_ORIGIN, IS_LOCAL_DEV } from 'config/envVariable';

const app = initializeApp(
    {
        apiKey: 'AIzaSyBoQHIyiH4g9Q7hWLO3oxjxxdohaMhPQf0',
        authDomain: 'auth.feversocial.com',
        projectId: 'feversocial-178308',
        storageBucket: 'feversocial-178308.appspot.com',
        messagingSenderId: '459719630125',
        appId: '1:459719630125:web:e06586c1c1ce6d4d9307a4',
        measurementId: 'G-77MXQYZT6C'
    },
    'fever-firebase'
);

export const auth = getAuth(app);

export function signout() {
    return signOut(auth);
}

const EXPIRE_IN_MINUTES = 30 * 60 * 1000;
let timeStamp = Date.now();
let firebaseToken = '';
export const firebaseTokenStaticGetter = {
    get token() {
        const now = Date.now();
        if (now - timeStamp >= EXPIRE_IN_MINUTES) {
            getFirebaseIdToken();
        }
        return firebaseToken;
    }
};
export async function getFirebaseIdToken() {
    if (auth.currentUser) {
        const t = await getIdToken(auth.currentUser);
        timeStamp = Date.now();
        firebaseToken = t;
        return t;
    } else {
        return '';
    }
}

export function getFirebaseUser() {
    return auth.currentUser;
}

export function getFirebaseUserUId() {
    const { uid } = auth.currentUser ?? {};
    return uid;
}

export function initFirebaseLogin() {
    return new Promise(res => {
        onAuthStateChanged(auth, user => {
            if (!user || !user.emailVerified) {
                toLoginPage();
            } else {
                res();
            }
        });
    });
}

export function toLoginPage() {
    window.location.replace(
        IS_LOCAL_DEV ? getDevLoginPageUrl() : getLoginPageUrl(window.location.href)
    );
}

function getDevLoginPageUrl() {
    return `${window.location.origin}/dev_login?${querystring.stringify({
        redirectUrl: window.location.href
    })}`;
}

export function getLoginPageUrl(refUrl) {
    return `${EDITOR_WINDOW_ORIGIN}/app/login?${querystring.stringify({
        refUrl
    })}`;
}
